const checkIfGizmoLink = (element) => {
	return element && element.classList && element.classList.toString().indexOf("gizmo-link") > -1;
};
const checkIfComponent = (element) => {
	return element.classList && element.classList.toString().indexOf("component") > -1;
};

const getClosestLinkParent = (current, loop) => {
	if (!current || loop > 10)
		// Loop max 10 out
		return false;
	if (current.nodeName === "A" || checkIfGizmoLink(current)) return current;
	else return getClosestLinkParent(current.parentElement, loop + 1);
};

const getClosestComponentParent = (current, loop) => {
	if (!current || loop > 20)
		// Loop max 20 out
		return false;
	if (checkIfComponent(current)) return current;
	else return getClosestComponentParent(current.parentElement, loop + 1);
};

const hasLinkChildren = (current, loop) => {
	if (!current || loop > 10)
		// Loop max 10 out
		return false;
	if (current.nodeName === "A" || checkIfGizmoLink(current)) return current;
	else {
		for (let i = 0; i < current.children.length; i++) {
			let linkFound = hasLinkChildren(current.children[i], loop + 1);
			if (linkFound) {
				i = current.children.length;
				return linkFound;
			}
		}
		return false;
	}
};

const getLinkTarget = (event) => {
	let target = event.target;
	target = target && target.nodeName !== "A" && !checkIfGizmoLink(target) ? getClosestLinkParent(target, 0) : target;
	if ((target && target.nodeName === "A") || checkIfGizmoLink(target)) {
		if ((!target.href || target.href === "") && target.dataset.href) target.href = target.dataset.href;
		if (target.href && target.href !== "") return target;
	}
	return false;
};

const getComponentTarget = (event) => {
	let target = event.target;
	target = !checkIfComponent(target) ? getClosestComponentParent(target, 0) : target;
	if (checkIfComponent(target)) {
		let link = hasLinkChildren(target);
		if ((!target.href || target.href === "") && link && link.dataset && link.dataset.href)
			target.href = link.dataset.href;
		if ((!target.href || target.href === "") && link && link.href) target.href = link.href;
		if (target.href && target.href !== "") return target;
	}
	return false;
};

const getFullElementHierarchy = (element, pathArray = []) => {
	if (!element) {
		console.log("No element found for hierarchy");
		return null;
	}
	let classNameString = "";
	if (element && element.classList && element.classList.length > 0) {
		element.classList.forEach((value) => {
			if (value !== "gizmo-link" && value.indexOf("hover") === -1) classNameString += "." + value;
		});
	}
	let text = pathArray.length === 0 ? element.innerText : ""; // element.textContent ||
	if (text !== "") text = "[" + text.trim() + "]";
	if (element && element.nodeName) pathArray.push(element.nodeName + classNameString + text);
	if (element && element.nodeName === "BODY") {
		pathArray = pathArray.reverse();
		return pathArray.join(" --> ");
	} else {
		return getFullElementHierarchy(element.parentElement, pathArray);
	}
};

const sendPostMessage = (href, elementHierarchy, productionOrigin) => {
	if (productionOrigin) href = href.replace(window.location.origin, productionOrigin);
	if (href.startsWith("/")) href = productionOrigin + href;
	parent.postMessage(
		{
			action: "select",
			payload: {
				href: href,
				path: elementHierarchy,
			},
		},
		"*",
	);
};

const initGizmoLinkSelectTriggerElement = (event, href, productionOrigin) => {
	let target = getLinkTarget(event);
	sendPostMessage(href, getFullElementHierarchy(target), productionOrigin);
	return false;
};

//http://localhost:9000/test/testseo.jsp?selectTriggerElement=true = Need the last parameter to run
/* testType: 0 => Link tracking, testType: 1 => Component tracking */
const initGobalSelectTriggerElement = (productionOrigin, testType = 0) => {
	let currentHover;
	try {
		testType = parseInt(testType);
	} catch {
		testType = 0;
	}
	document.addEventListener("mouseover", function (e) {
		let target = testType === 0 ? getLinkTarget(e) : getComponentTarget(e);
		if (target) {
			if (currentHover && currentHover !== target && currentHover.classList) {
				currentHover.classList.remove("selectTriggerElement-hover");
				currentHover = undefined;
			}
			currentHover = target;
			if (currentHover && currentHover.classList) currentHover.classList.add("selectTriggerElement-hover");
		}
	});
	document.addEventListener("mouseout", function (e) {
		let target = testType === 0 ? getLinkTarget(e) : getComponentTarget(e);
		if (target) {
			if (currentHover && currentHover === target && currentHover.classList) {
				currentHover.classList.remove("selectTriggerElement-hover");
				currentHover = undefined;
			}
		}
	});

	document.addEventListener(
		"click",
		function (e) {
			e.preventDefault();
			e.stopPropagation();

			let target = testType === 0 ? getLinkTarget(e) : getComponentTarget(e);
			if (target && parent) {
				try {
					sendPostMessage(target.href, getFullElementHierarchy(target), productionOrigin);
				} catch (e) {
					console.log("Error: ", e);
				}
			}
			return false;
		},
		false,
	);

	const style = `
    <style type="text/css">
        .selectTriggerElement-hover {
            position: relative;
        }
        
        .selectTriggerElement-hover:after {
            content: "";
            display: block;
            position: absolute;
            left: -3px;
            top: -3px;
            right: -3px;
            bottom: -3px;
            background: rgba(0,120,207,0.18);
            border: 2px dotted #0078cf; 
            border-radius: 3px;
        }
    </style>`;

	let head = document.getElementsByTagName("head");
	if (head.length > 0) head[0].insertAdjacentHTML("beforeend", style);
};

export default {
	initGobalSelectTriggerElement,
	initGizmoLinkSelectTriggerElement,
};
